export default "__VITE_ASSET__03811777__"